import axios from 'axios'

const base_url = process.env.REACT_APP_BASE_URL || 'http://localhost:5000'

export interface FileItem {
  name: string
  path: string
  isDirectory: boolean
  size?: number
  lastModified?: string
  contentType?: string
}

export interface PaginatedFilesResponse {
  totalCount: number
  pageNumber: number
  pageSize: number
  totalPages: number
  items: FileItem[]
}

export async function listFiles(
  directoryPath: string = '',
  pageNumber: number = 1,
  pageSize: number = 25
): Promise<PaginatedFilesResponse> {
  const response = await axios.get<PaginatedFilesResponse>(`${base_url}/api/files`, {
    params: { path: directoryPath, pageNumber, pageSize },
    skipErrorNotification: true,
  } as any)
  return response.data
}

export async function downloadFile(filePath: string): Promise<Blob> {
  const response = await axios.post(`${base_url}/api/files/download`, [filePath], {
    responseType: 'blob',
    skipErrorNotification: true,
  } as any)
  return response.data
}

export async function downloadFilesAsZip(filePaths: string[]): Promise<Blob> {
  const response = await axios.post(`${base_url}/api/files/download/zip`, filePaths, {
    responseType: 'blob',
    skipErrorNotification: true,
  } as any)
  return response.data
}

export async function uploadFile(
  file: File,
  filePath: string
): Promise<{ message: string; path: string }> {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('filePath', filePath)

  const response = await axios.post(`${base_url}/api/files/upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    skipErrorNotification: true,
  } as any)
  return response.data
}

export async function deleteFile(filePath: string): Promise<{ message: string }> {
  const response = await axios.delete(
    `${base_url}/api/files/${encodeURIComponent(filePath)}`,
    {
      skipErrorNotification: true,
    } as any
  )
  return response.data
}
